import React from 'react';
import styled from 'styled-components';

const PrivacyPolicyWrapper = styled.div`
  color: rgba(84, 84, 84, 0.56);
  margin-top: 8px;
  font-size: 13px;
  text-align: center;
`;

const LinkWrapper = styled.a`
  color: rgba(84, 84, 84, 0.56);
  text-decoration: underline;
  &:hover {
    color: rgba(84, 84, 84, 0.8);
  }
`;

export const PrivacyPolicy = () => {
  return <PrivacyPolicyWrapper>
    By continuing, you accept our <LinkWrapper href="https://oligo.com.au/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy
    Policy</LinkWrapper> and <LinkWrapper href="https://oligo.com.au/legal/ " target="_blank" rel="noopener noreferrer">T&Cs</LinkWrapper>
  </PrivacyPolicyWrapper>;
};
